import { Navigate, Route } from "react-router-dom";
import { leaves, routes } from "~/constants";
import { Protector } from "./Protector";
import { lazy, lazyLoadLandingPages, rrPath } from "./utils";

const ArticlePage = lazyLoadLandingPages("ArticlePage");

const AuthorPage = lazyLoadLandingPages("AuthorPage");

const FaqsPage = lazyLoadLandingPages("FaqsPage");

const GatheringPage = lazyLoadLandingPages("GatheringPage");

const GatheringsPage = lazyLoadLandingPages("GatheringsPage");

const LibraryPage = lazyLoadLandingPages("LibraryPage");

const MedicalReviewerPage = lazyLoadLandingPages("MedicalReviewerPage");

const TopicPage = lazyLoadLandingPages("TopicPage");

export const SharedRoutes = (
  <>
    <Route path={leaves.faqs} element={lazy(<FaqsPage />)} />
    <Route path={leaves.events}>
      <Route index element={lazy(<GatheringsPage />)} />
      <Route path={rrPath(leaves.slug)} element={lazy(<GatheringPage />)} />
    </Route>
    <Route path={leaves.library}>
      <Route index element={lazy(<LibraryPage />)} />
      <Route path={rrPath(leaves.topic)}>
        <Route index element={lazy(<TopicPage />)} />
        <Route
          path={rrPath(leaves.slug)}
          element={<Protector>{lazy(<ArticlePage />)}</Protector>}
        />
      </Route>
      <Route path={rrPath(leaves.medicalReviewer)}>
        <Route index element={<Navigate to={routes.library} />} />
        <Route
          path={rrPath(leaves.slug)}
          element={lazy(<MedicalReviewerPage />)}
        />
      </Route>
      <Route path={rrPath(leaves.author)}>
        <Route index element={<Navigate to={routes.library} />} />
        <Route path={rrPath(leaves.slug)} element={lazy(<AuthorPage />)} />
      </Route>
    </Route>
  </>
);
